import { useEffect, useState } from "react";
import { Button, Loading, PageFooter } from "@quark/design";
import styles from "./index.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { getPage, submitPageProgress } from "../../api";
import PunchCard from "../../component/punch-card";
import useDocumentTitle from "../../hooks/use-document-title";
import { HIDE_ASSISTANT_EVENT } from "../../constants";

const Completed = () => {
  const navigate = useNavigate();
  const { courseId, pageId } = useParams<{
    courseId: string;
    pageId: string;
  }>();
  const [firstCompleted, setFirstCompleted] = useState<boolean>(false);
  const [punchLoaded, setPunchLoaded] = useState<boolean>(false);
  useDocumentTitle("学习完成");
  useEffect(() => {
    if (!courseId || !pageId) {
      return;
    }
    getPage(courseId, pageId)
      .then((data) => {
        if (data.status !== "done") {
          setFirstCompleted(true);
        }
      })
      .then(() => {
        submitPageProgress(courseId, pageId);
      });
  }, [courseId, pageId]);

  // 超时5秒后显示继续
  useEffect(() => {
    window.dispatchEvent(new Event(HIDE_ASSISTANT_EVENT));
    setTimeout(() => {
      setPunchLoaded(true);
    }, 5000);
  }, []);

  const handleContinue = () => {
    navigate(`/course/${courseId}/catalog`, { replace: true });
  };

  const renderDiamond = () => {
    if (!firstCompleted) {
      return <div style={{ height: 89 }} />;
    }
    return (
      <div className={styles.firstCompleted}>
        <div>你获得了：</div>
        <div className={styles.diamond}>
          +10 <i />
        </div>
      </div>
    );
  };

  return (
    <div className={styles.completed}>
      <div className={styles.picture} />
      <div className={styles.title}>学习完成</div>
      <div className={styles.description}>
        你可以学习其他课程了，但是不要忘记用练习去测试你的知识！
      </div>
      {renderDiamond()}
      <PageFooter className="snapshot-ignore">
        {punchLoaded ? (
          <Button variant="filled" onClick={handleContinue}>
            继续
          </Button>
        ) : (
          <Loading />
        )}
      </PageFooter>

      <PunchCard
        className={styles.punchCard}
        params={{ course_no: courseId!, page_id: Number(pageId) }}
        onLoad={() => setPunchLoaded(true)}
      />
    </div>
  );
};

export default Completed;
